module.exports = __webpack_public_path__ + "img/book4.808a6082.jpg";